const raleway = 'Raleway';
const open_sans = "Open Sans";

const _container_padding = (download: boolean) => {
  return {
    "padding": "0 95px"
  }
}

const _description = (download: boolean) => {
  return {
    "font-size": "20px",
    "padding": "0 16px",
    'font-family':  open_sans,
    'background-color': 'white'
  }
}

const _paragraph = (download: boolean) => {
  return {
    "font-family": open_sans,
    "font-size": "22px",
    "width": "100%",
    "text-align": "left",
  }
}

const _generalH1 = (download: boolean) => {
  return {
    "font-family": raleway,
    "font-size": download ? "45px" : "32px",
    "font-weight": "bold",
    "padding-top": "30px",
    "padding-bottom": "20px",
    
  }
}

const _generalH2 = (download: boolean) => {
  return {
    "font-family": "Raleway",
    "font-size": "24px",
    "font-weight": "bold",
    "margin-bottom": "20px",
    "margin-top": download ? "34px;" : 0
  }
}

const _styles_name  = (download: boolean) => {
  return {
    "font-size": "24px",
    "width": "200px",
    "height": "100px",
    "color": "white",
    "text-align": "center",
    "font-weight": "bold",
    "font-family": raleway,
  }
}


export const getStyles = (download: boolean) => {
  return {
    container_padding: _container_padding(download),
    paragraph: _paragraph(download),
    general_h1: _generalH1(download),
    general_h2: _generalH2(download),
    page: {
      "position": "relative",
      "background": "white",
      "padding": download ? "0" : "2rem",
      "width": download ? "1400px" : '1100px',
      "height": download ? '1400px' : 'auto'
    },
    front_page: {
      logo: {
        "padding-top": "83px",
        "padding": "0 95px",
        "text-align": 'right',
      },
      image: {
        "margin-left": "auto",
        "margin-right": "auto",
        "padding": "0 95px"
      },
      container: {
        "background-color": "black",
        "padding": "0 95px",
        "padding-top": "50px", 
        "padding-bottom": "50px",
      },
      content: {
        "color": "white",
        "border-left": "solid 8px white",
        "padding": "1rem 2.5rem",
      },
      template: {
        "font-size": download ? "48px" : "35px",
        "font-family": raleway, 
        "padding": download ? "0" : "1rem 0"
      },
      report: {
        "font-size": download ? "85px" : "70px",
        "font-family": raleway, 
        "padding":  download ? "0" : "1rem 0"
      },
      name: {
        "font-size": download ? "27px" : "25px",
        "font-family": "raleway"
      }
    },
    page_header: {
      ..._container_padding(download),
      "font-family": raleway,
      "margin-bottom": "40px",
      "padding-top": "40px",
    },
    table: {
      "border-color": "transparent",
      "border-collapse": "collapse"
    },
    header: {
      text: {
        ..._container_padding(download),
        "font-family": raleway,
        "font-size": "38px",
        "padding-top": "34px",
        "padding-bottom": "34px",
      },
      line: {
        "height": "8px",
        "background-color": "#266cf7",
        "width": "50%"
      },
      page: {
        "font-family": raleway,
        "margin-bottom": "40px",
        "padding-top": "40px",
      },
    },
    styles: { 
      description: _description(download),
      description_odd: {
        ..._description(download),
        "background-color": "#f3f3f3",
      },
      name: _styles_name(download),
      odd: {
        ..._styles_name(download),
        "background-color": "rgb(38, 108, 247)"
      },
      even: {
        ..._styles_name(download),
        "background-color": "rgba(38, 108, 247, 0.7)"
      },
      note: {
        "margin-top": "40px",
        "font-style": "italic",
      }
    },
    graph: {
      "margin": "0 0 60px"
    },
    highlight: {
      "color": "#266cf7",
      "font-weight": "700",
    }
  }
} 